import React from 'react';
import c from 'classnames';

import {
  Icon,
  Image,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

type Props = {
  title: string,
  subtitle?: string,
  link: string,
  labelLinkTitle: string,
  imageUrl: string[],
  titleClassName?: string,
};

const LinkListPrimaryItem: React.FC<Props> = (props) => {
  const {
    title,
    subtitle,
    link,
    imageUrl,
    labelLinkTitle,
    titleClassName,
  } = props;

  const classes = c('LinkListItemNormal');
  const titleClasses = c('LinkListItemNormal__title', titleClassName);

  return (
    <div
      // @ts-ignore
      className={classes}
    >
      <Image src={imageUrl} alt={title} lazyload={false} />
      <div className="LinkListItemNormal__content">
        <div className={titleClasses}>
          <h3>{title}</h3>
        </div>
        <span className="LinkListItemNormal__subtitle__text">{subtitle}</span>
        <CoreLink className="LinkListItemNormal__label__link" href={link} tabIndex={-1}>{labelLinkTitle}<Icon name="arrow_forward" /></CoreLink>
      </div>
    </div>
  );
};

export default LinkListPrimaryItem;
